"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as t } from "react/jsx-runtime";
import { useTheme as c } from "../../hooks.js";
import { useIsInverseVariant as l } from "../../theme-variant-context.js";
import { vars as n } from "../../skins/skin-contract.css-mistica.js";
const a = (_param)=>{
    var { color: i, size: e = 24 } = _param, h = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const v = l(), o = i !== null && i !== void 0 ? i : v ? n.colors.inverse : n.colors.neutralHigh, { skinName: r } = c();
    return r.match(/^vivo-new/i) ? /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, h), {
        children: /* @__PURE__ */ t("path", {
            fill: o,
            d: "M3.176 5.455c0-.71.58-1.286 1.295-1.286h15.058a1.29 1.29 0 0 1 1.294 1.286v9.35c0 .71-.579 1.286-1.294 1.286H4.471a1.29 1.29 0 0 1-1.295-1.286zm9.412 11.805h6.941A2.463 2.463 0 0 0 22 14.805v-9.35A2.463 2.463 0 0 0 19.53 3H4.47A2.463 2.463 0 0 0 2 5.455v9.35a2.463 2.463 0 0 0 2.47 2.455h6.942v2.571H8.235a.586.586 0 0 0-.588.585c0 .322.263.584.588.584h7.53a.586.586 0 0 0 .588-.584.586.586 0 0 0-.588-.585h-3.177z"
        })
    })) : r.match(/^o2-new/i) ? /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, h), {
        children: /* @__PURE__ */ t("path", {
            fill: o,
            d: "M22 17.662V4H2v13.662h7.966v1.169H7.557c-.308 0-.555.26-.555.584 0 .325.247.585.555.585h8.89c.309 0 .555-.26.555-.585s-.246-.584-.554-.584h-2.41v-1.17zm-18.52-1.56V5.564h17.04v10.538zm7.59 2.734v-1.17h1.855v1.17z"
        })
    })) : r.match(/^o2/i) ? /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, h), {
        children: /* @__PURE__ */ t("path", {
            fill: o,
            d: "M22 17.662V4H2v13.662h7.966v1.169H7.557c-.308 0-.555.26-.555.584 0 .325.247.585.555.585h8.89c.309 0 .555-.26.555-.585s-.246-.584-.554-.584h-2.41v-1.17zm-18.52-1.56V5.564h17.04v10.538zm7.59 2.734v-1.17h1.855v1.17z"
        })
    })) : /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, h), {
        children: /* @__PURE__ */ t("path", {
            fill: o,
            d: "m18.402 17.323-12.804-.008c-1.12 0-1.99-.311-2.58-.927-.574-.591-.863-1.437-.863-2.513V7.878c0-2.202 1.221-3.412 3.44-3.412l12.807.009c2.218 0 3.44 1.212 3.44 3.411v5.998c0 1.075-.29 1.921-.86 2.512-.594.616-1.463.927-2.58.927M5.594 5.587c-.807 0-1.406.193-1.779.574-.358.367-.54.944-.54 1.717v5.997c0 1.583.736 2.32 2.319 2.32l12.804.008c1.582 0 2.32-.737 2.32-2.32V7.887c0-.773-.183-1.35-.544-1.717-.373-.38-.97-.574-1.78-.574zm3.941 13.94 4.916.01c.308 0 .56-.253.56-.561a.56.56 0 0 0-.56-.56l-4.916-.009a.56.56 0 0 0-.56.56c0 .309.252.56.56.56"
        })
    }));
}, p = a;
export { p as default };
